import { render } from "./indexFooterfixed.vue?vue&type=template&id=663741a6"
import script from "./indexFooterfixed.vue?vue&type=script&lang=js"
export * from "./indexFooterfixed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__